<template>
  <div class="container">
    <!-- desktop -->
    <div class="d-none d-md-block">
      <div class="row mt-3">
        <div class="col-md-6">
          <div class="d-flex h-100">
            <div class="justify-content-center align-self-center">
              <h2>
                <strong>{{ transporter }}</strong><br />
              </h2>
              <h3>AMA Transport management Sistem (Claim)</h3>
              <router-link to="./klaim" class="btn btn-danger"
                >
                Klaim
                <v-icon color="lighten-2" style="color:white">
                        mdi-arrow-right
                      </v-icon>
                </router-link
              >
            </div>
          </div>
        </div>
        <div class="col col-md-6">
          <img src="../assets/tms.png" style="width: 100%" alt="" srcset="" />
        </div>
      </div>
    </div>
    <!-- mobile -->
    <div class="d-sm-block d-md-none">
      <div class="row mt-3">
        <div class="col-md-6">
          <div class="d-flex h-100">
            <div class="justify-content-center align-self-center">
              <h2>
                <strong>{{ transporter }}</strong><br />
              </h2>
              <h3>AMA Transport management Sistem (Claim)</h3>
              <router-link to="./klaim" class="btn btn-danger"
                >
                Klaim
                <v-icon color="lighten-2" style="color:white">
                        mdi-arrow-right
                      </v-icon>
                </router-link
              >
            </div>
          </div>
        </div>
        <div class="col col-md-6">
          <img src="../assets/tms.png" style="width: 100%" alt="" srcset="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: `BannerPoster`,
  data() {
    return {
      transporter: '',
    };
  },
  created(){
    this.transporter = localStorage.getItem('transporter_name')
  },
 
};
</script>

<style>
.circle-mobile {
  border-radius: 50%;
  float: left;
  display: inline-block;
  margin-right: 20px;
  /* text styling */
  font-size: 15px;
  width: 100px;
  height: 100px;
  color: #fff;
  border: 2px solid #fff;
  line-height: 100px;
  text-align: center;
}
.circle {
  border-radius: 50%;
  float: left;
  display: inline-block;
  margin-right: 20px;
  /* text styling */
  font-size: 45px;
  width: 250px;
  height: 250px;
  color: #fff;
  border: 2px solid #fff;
  line-height: 250px;
  text-align: center;
}
.color-1 {
  background: #4646f5;
}
.color-2 {
  background: #aea79f;
}
.color-3 {
  background: #5e2750;
}
.color1-box-shadow {
  box-shadow: 0px 0px 1px 1px #dd4814;
}
.color2-box-shadow {
  box-shadow: 0px 0px 1px 1px #aea79f;
}
.color3-box-shadow {
  box-shadow: 0px 0px 1px 1px #5e2750;
}
.text {
  line-height: 45px;
  padding-top: 50px;
  height: 200px;
}
</style>